import { formatThousands } from '../../../utils/format/formatNumber';
import { getReportContent } from '../utils/getReportContent';
import ReportChart from './ReportChart';
import { SALES_REPORT_ALL_ITEMS, SALES_REPORT_SILOVE_ITEMS, SALES_REPORT_SINOR_ITEMS } from './ReportChart.attribute';
import ReportItem from './ReportItem';
import * as S from './SalesReport.style';

export default function SalesReport({ variant = 'amount', dateType, current, previous, category }) {
    const { title, barName, compareDate } = getReportContent(variant, dateType);
    const difference = current.sales[variant].total - previous.sales[variant].total;

    const unit = variant === 'amount' ? '원' : '건';
    const formattedDifference = formatThousands(difference, unit);
    const salesTrend = difference > 0 ? 'INCREASE' : difference < 0 ? 'DECREASE' : 'NEUTRAL';
    const differDescription = salesTrend === 'INCREASE' ? `${formattedDifference} 늘었어요` : salesTrend === 'DECREASE' ? `${formattedDifference} 줄었어요` : '동일해요';
    const reportItems = category === 'all' ? SALES_REPORT_ALL_ITEMS : category === 'sinor' ? SALES_REPORT_SINOR_ITEMS : SALES_REPORT_SILOVE_ITEMS;
    const pointKey = variant === 'amount' ? 'total' : 'count';

    return (
        <S.SalesReportContainer>
            <S.SalesContentWrapper>
                <S.SalesReportDescription>
                    <S.DescriptionText>
                        {title}
                        <S.DescriptionRateText $salesTrend={salesTrend}>{differDescription}</S.DescriptionRateText>
                    </S.DescriptionText>
                    <S.DescriptionUl>
                        {reportItems.map((item) => {
                            const value = item.id === 'refunds' ? current.refunds[variant] : item.id === 'point' ? current.sales.point[pointKey] : current.sales[variant][item.key];
                            return <ReportItem item={item} value={value} key={item.key} />;
                        })}
                    </S.DescriptionUl>
                </S.SalesReportDescription>

                <ReportChart barName={barName} compareDate={compareDate} current={current} previous={previous} category={category} variant={variant} />
            </S.SalesContentWrapper>
        </S.SalesReportContainer>
    );
}
